
import { Component, Prop, Vue } from "vue-property-decorator";
import QDialog from 'quasar/src/components/dialog/QDialog.js';import QMenu from 'quasar/src/components/menu/QMenu.js';;

const SEPARATOR = "|";

function stripFlags(pattern: any) {
  return String(pattern).replace(/^\(\?i\)/, "");
}

const OPERATORS = [
  { label: "Равно", value: "$eq" },
  { label: "Не равно", value: "$ne" },
  { label: "Больше", value: "$gt" },
  // { label: "Больше или равно", value: "$gte" },
  { label: "Меньше", value: "$lt" },
  //{ label: "Меньше или равно", value: "$lte" },
  { label: "Одно из", value: "$in" },
  { label: "Ни одно из", value: "$nin" },
  { label: "Содержит", value: "$regex" },
  { label: "Не содержит", value: "$nregex" },
  { label: "Существует", value: "$exists" }
];

@Component
export default class SearchFilter extends Vue {
  @Prop({ default: () => [] }) columns!: any[];
  @Prop({ default: () => ({}) }) value!: Record<string, any>;

  menu = false;
  fieldSearch = "";
  selectedField = "";
  selectedOperator = "$eq";
  operations: Record<string, any> = {};

  get isMobile() {
    return this.$q.screen.lt.sm;
  }

  get popupComponent() {
    return this.isMobile ? QDialog : QMenu;
  }

  get popupProps() {
    return this.isMobile
      ? { position: "bottom", fullWidth: true }
      : {
          anchor: "bottom left",
          self: "top left",
          offset: [0, 10],
          noParentEvent: true
        };
  }

  get fields() {
    const seen = new Set<string>();

    return (
      (this.columns || [])
        .filter(col => col && typeof (col.field || col.name) === "string")
        .map(col => ({
          label: col.label || col.name || col.field,
          value: col.field || col.name,
          col
        }))
        // Несколько колонок могут показывать одно поле (например, «Цена» и
        // «Цена $» — обе steamItemsPrice); фильтровать по нему нужно один раз
        .filter(({ value }) => {
          if (seen.has(value)) {
            return false;
          }
          seen.add(value);
          return true;
        })
    );
  }

  get visibleFields() {
    const needle = (this.fieldSearch || "").toLowerCase();

    return needle
      ? this.fields.filter(
          field =>
            String(field.label)
              .toLowerCase()
              .indexOf(needle) !== -1 ||
            field.value.toLowerCase().indexOf(needle) !== -1
        )
      : this.fields;
  }

  get activeCount() {
    return Object.keys(this.value || {}).length;
  }

  get operatorOptions() {
    const type = this.columnType(this.selectedField);

    if (type === "boolean") {
      return OPERATORS.filter(
        operator => ["$eq", "$ne", "$exists"].indexOf(operator.value) !== -1
      );
    }

    if (type === "number") {
      return OPERATORS.filter(
        operator => ["$regex", "$nregex"].indexOf(operator.value) === -1
      );
    }

    return OPERATORS;
  }

  get currentKey() {
    return `${this.selectedField}${SEPARATOR}${this.selectedOperator}`;
  }

  get currentValue() {
    return this.operations[this.currentKey];
  }

  get activeChips() {
    return Object.keys(this.operations)
      .filter(key => this.hasValue(this.operations[key], key))
      .map(key => {
        const [field, op] = key.split(SEPARATOR);
        const column = this.column(field);
        const operator = OPERATORS.find(item => item.value === op);
        const raw = this.operations[key];
        const shown = op === "$exists" ? (raw ? "да" : "нет") : raw;

        return {
          key,
          label: `${column ? column.label : field} ${
            operator ? operator.label.toLowerCase() : op
          }: ${shown}`
        };
      });
  }

  column(field: string) {
    return this.fields.find(item => item.value === field);
  }

  columnType(field: string) {
    const found = this.column(field);

    return found ? found.col.type : undefined;
  }

  enumOptions(field: string) {
    const found = this.column(field);

    return found && found.col.enum && found.col.enum.length
      ? found.col.enum
      : null;
  }

  optionValue(field: string) {
    const found = this.column(field);

    return found ? found.col.optionValue : undefined;
  }

  optionLabel(field: string) {
    const found = this.column(field);

    return found ? found.col.optionLabel : undefined;
  }

  isListOperator(op: string) {
    return op === "$in" || op === "$nin";
  }

  // Классы чипа поля/условия: выбранный — синий, с заданным условием — с зелёной точкой
  chipClass(hasValue: boolean, selected: boolean) {
    return {
      "sf-chip--selected": selected,
      "sf-chip--has-value": hasValue
    };
  }

  get selectedFieldLabel() {
    const field = this.fields.find(({ value }) => value === this.selectedField);
    return field ? field.label : "";
  }

  hasValue(raw: any, key: string) {
    const [, op] = key.split(SEPARATOR);

    if (op === "$exists") {
      return raw === true || raw === false;
    }

    return raw !== "" && raw !== null && raw !== undefined;
  }

  fieldHasValue(field: string) {
    return Object.keys(this.operations).some(
      key =>
        key.split(SEPARATOR)[0] === field &&
        this.hasValue(this.operations[key], key)
    );
  }

  operationHasValue(field: string, op: string) {
    const key = `${field}${SEPARATOR}${op}`;

    return this.hasValue(this.operations[key], key);
  }

  isFieldSelected(field: string) {
    return this.selectedField === field;
  }

  selectField(field: string) {
    this.selectedField = field;

    if (
      this.operatorOptions
        .map(operator => operator.value)
        .indexOf(this.selectedOperator) === -1
    ) {
      this.selectedOperator = "$eq";
    }
  }

  setValue(raw: any) {
    this.$set(this.operations, this.currentKey, raw);
  }

  removeOperation(key: string) {
    this.$delete(this.operations, key);
  }

  valueHint(op: string) {
    if (this.isListOperator(op)) {
      return "Через запятую или пробел";
    }

    if (op === "$regex" || op === "$nregex") {
      return "Регулярное выражение, регистр не важен";
    }

    return undefined;
  }

  cast(field: string, raw: any) {
    if (raw === null || raw === undefined) {
      return raw;
    }

    const type = this.columnType(field);

    if (type === "boolean") {
      return raw === true || raw === "true";
    }

    if (type === "number") {
      const num = Number(raw);

      return raw !== "" && !isNaN(num) ? num : raw;
    }

    return raw;
  }

  get condition() {
    const result: Record<string, any> = {};

    Object.keys(this.operations).forEach(key => {
      const raw = this.operations[key];

      if (!this.hasValue(raw, key)) {
        return;
      }

      const [field, op] = key.split(SEPARATOR);
      let expression: Record<string, any>;

      switch (op) {
        case "$regex":
          expression = { $regex: `(?i)${raw}` };
          break;
        case "$nregex":
          expression = { $not: { $regex: `(?i)${raw}` } };
          break;
        case "$in":
        case "$nin":
          expression = {
            [op]: String(raw)
              .split(/[\s,]+/)
              .filter(Boolean)
              .map(item => this.cast(field, item))
          };
          break;
        case "$exists":
          expression = { $exists: raw === true };
          break;
        default:
          expression = { [op]: this.cast(field, raw) };
      }

      result[field] = { ...(result[field] || {}), ...expression };
    });

    return result;
  }

  syncFromValue() {
    const source = this.value || {};
    const operations: Record<string, any> = {};

    Object.keys(source).forEach(field => {
      const expression = source[field];

      if (
        !expression ||
        typeof expression !== "object" ||
        Array.isArray(expression)
      ) {
        operations[`${field}${SEPARATOR}$eq`] = expression;
        return;
      }

      Object.keys(expression).forEach(op => {
        const raw = expression[op];

        if (op === "$options") {
          return;
        }

        if (op === "$regex") {
          operations[`${field}${SEPARATOR}$regex`] = stripFlags(raw);
          return;
        }

        if (op === "$not" && raw && raw.$regex) {
          operations[`${field}${SEPARATOR}$nregex`] = stripFlags(raw.$regex);
          return;
        }

        if (op === "$in" || op === "$nin") {
          operations[`${field}${SEPARATOR}${op}`] = (raw || []).join(", ");
          return;
        }

        if (OPERATORS.some(operator => operator.value === op)) {
          operations[`${field}${SEPARATOR}${op}`] = raw;
        }
      });
    });

    this.operations = operations;

    if (!this.selectedField && this.fields.length) {
      this.selectedField = this.fields[0].value;
    }
  }

  apply() {
    this.$emit("input", this.condition);
  }

  clear() {
    this.operations = {};
    this.$emit("input", {});
  }

  created() {
    this.syncFromValue();
  }
}
